import {get, post} from "@/utils/http"

export const _getAccountPasswordList = params => get("/accountPassword/selectPages", params); // 列表
export const _delAccountPassword = params => get("/accountPassword/delete", params); // 删除
export const _editAccountPassword = params =>post(params.id ? "/accountPassword/update" : "/accountPassword/save", params); // 编辑/创建
